import {Asset} from '../item/asset.model';
import {SellerLocation} from '../item/sellerLocation.model';
import {AssetLien} from '../item/asset-lien.model';
import {
  ASSET_PACKAGE_STATUS_CONTRACTED,
  ASSET_PACKAGE_STATUS_IN_PRICING,
  ASSET_PACKAGE_STATUS_RESENT_FOR_PRICING,
  ASSET_PACKAGE_STATUS_SENT_FOR_PRICING
} from './asset-package-status-type';
import {OpportunityPackageVisibility} from "../opportunity";

export class AssetPackageDto {
  assetPackageName: string;
  opportunityId: number;
  locationId: number;
  sellerLocation: SellerLocation;
  acgSellerLocationId: number;
  acgStatus: string;
  acgStatusId: number;
  acgId: number;
  territoryManagerId: number;
  assets: Array<Asset> = [];
  acgOwnerUserName: string;
  defaultAuctionEventId: number;
  defaultInspectionType: string;
  defaultSaleType: string;
  defaultYardDeliveyDt: Date;
  defaultSiteId: number;
  assetCount: number;
  doesCustomerOwesMoney: string;
  rnrBudgetLimit: number;
  haulingBudgetLimit: number;
  salesHubContractId: any;
  salesHubContractNumber: any;
  salesHubOpportunityId: string;
  contractId: any;
  rnrBudgetRollup: number;
  haulingBudgetRollup: number;
  displayName: string;
  acgTMUserName: string;
  acgSalesCordinator: string;
  currency: string;
  ppsPackageId: number = 0;
  assetLienDtos: Array<AssetLien>;
  lastACGSyncSuccess: boolean;
  packageType: string;
  isMissingOwnerCode: boolean;
  auctionSite: boolean = true;
  contractRecordType: string;
  opportunityRecordType: string;
  yomVerification: boolean;
  isMarsOperated: boolean;
  isSalesHubNonMarsContract: boolean;
  isContractSigned: boolean;
  contractStatus : string;
  packageTeam : string;
  defaultAuctionEvent : string;
  lockYn: string;
  isIPWebOperated: boolean;
  isPackageNeedsToReview:boolean;
  hasPostContractAssets:boolean;
  hasVsoAssets : boolean;
  packageVisibility : string;

  customRowCssClass : string;


  public static constructFromSearchListJson(objectListJson: any[]): AssetPackageDto[] {
    const searchList: AssetPackageDto[] = [];
    if (!objectListJson) return searchList;
    for (const objectJson of objectListJson) {
      const itemDto: AssetPackageDto = AssetPackageDto.constructFromObjectJson(objectJson);
      itemDto.customRowCssClass = 'cursor-pointer';
      searchList.push(itemDto);
    }

    return searchList;
  }

  public static constructFromObjectJson(objectJson: any): AssetPackageDto {
    let packageDto : AssetPackageDto = Object.assign(new AssetPackageDto(), objectJson);
    packageDto.customRowCssClass = 'cursor-pointer';
    return packageDto;
  }

  public isPackageInPricing(): boolean {
    return this.acgStatusId === ASSET_PACKAGE_STATUS_SENT_FOR_PRICING
      || this.acgStatusId === ASSET_PACKAGE_STATUS_IN_PRICING
      || this.acgStatusId === ASSET_PACKAGE_STATUS_RESENT_FOR_PRICING
      || this.isPackageContractedAndLocked();
  }
  public isPackageContractedAndLocked(): boolean {
    return this.acgStatusId === ASSET_PACKAGE_STATUS_CONTRACTED &&
      this.lockYn === 'Y';
  }

  public isPackageConfidential(): boolean {
    return this.packageVisibility === OpportunityPackageVisibility.TYPE_CONFIDENTIAL
      && (!this.opportunityId || !!this.opportunityId
      && this.opportunityRecordType === OpportunityPackageVisibility.TYPE_CONFIDENTIAL);
  }

  public isVisibilityChangeable(): boolean {
    return (!this.opportunityId) ||
      (this.opportunityId && this.opportunityRecordType === OpportunityPackageVisibility.TYPE_CONFIDENTIAL);
  }
}
